import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import DatAIDetails from './section-components/data-ai-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const DATAAI = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Best Trusted IT Courses | Data Science and AI Courses Chennai</title>
            <meta name="description" content="MIET Chennai offers high-quality IT, Data Science and AI courses at the most affordable price. Register today and get the best deal on any of our IT courses." />
        </Helmet>
        <PageHeader headertitle="Information Technology Courses"  />
        <DatAIDetails />
        <Footer />
    </div>
}

export default DATAAI